import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const location = useLocation();
  const { pathname, state } = location;

  useEffect(() => {
    // If coming back to list with focus request, don't scroll to top
    if (state?.focusOnCard) {
      return;
    }
    
    // Check if focus marker exists in sessionStorage
    try {
      if (sessionStorage.getItem('focusRestaurantId') || sessionStorage.getItem('focusHotelId')) {
        return;
      }
    } catch (e) {}
    
    // Otherwise scroll to top
    window.scrollTo(0, 0);
  }, [pathname, state]);

  return null;
}
